"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _ScaleLine = _interopRequireDefault(require("ol/control/ScaleLine"));

require("ol/ol.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A control displaying rough y-axis distances, calculated for the center of the viewport.
 * By default the scale line will show in the bottom left portion of the map, but this can 
 * be changed by using the css selector .ol-scale-line. When specifying bar as true, a 
 * scalebar will be rendered instead of a scaleline.
 * 
 * @visibleName ScaleLine Control
 */
var ScaleLineControl = function ScaleLineControl(_ref) {
  var map = _ref.map,
      options = _ref.options;
  (0, _react.useEffect)(function () {
    var control = new _ScaleLine.default(options);
    map.addControl(control);
    return function () {
      map.removeControl(control);
    };
  }, [map, options]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};

ScaleLineControl.propTypes = {
  /**
   * The OpenLayers ol/Map on where the component
   * will zoom.
   */
  map: _propTypes.default.instanceOf(_ol.Map),

  /**
   * The options for the component. It is 
   * the same used for the openlayers 
   * <a href="https://openlayers.org/en/latest/apidoc/module-ol_control_ScaleLine-ScaleLine.html">
   * ol/control/ZoomScaleLine</a>
   */
  options: _propTypes.default.object
};
var _default = ScaleLineControl;
exports.default = _default;